module.exports = __webpack_public_path__ + "img/chinesecompany185.46be9b91.png";